export const reservation = {
  status: {
    applied: "applied",
    arranged: "arranged",
    cancel_applied: "cancel applied",
    cancelled: "cancelled",
  },
};
